import { render } from "./ShipmentsCheckoutGridRow.vue?vue&type=template&id=a4660cd2"
import script from "./ShipmentsCheckoutGridRow.vue?vue&type=script&lang=js"
export * from "./ShipmentsCheckoutGridRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__